import { useTranslation } from "@impero-com/common/utils/i18n";

import { CustomEllipsisLabel } from "components/table/tsTable/CustomEllipsisLabel";
import { useControlProgramsSuspenseQuery } from "org/control/queries/useControlProgramsQuery";

import { MultipleOptionFilterSelect } from "./MultipleOptionFilterSelect";

interface ControlProgramFilterProps {
    value: number[];
    onChange: (value: number[]) => void;
}

export function ControlProgramFilter({
    value,
    onChange,
}: ControlProgramFilterProps) {
    const { t } = useTranslation();
    const { data: controlProgramsData } = useControlProgramsSuspenseQuery();

    const options = controlProgramsData.content.map(
        ({ resource: { controlProgram } }) => ({
            label: controlProgram.name,
            value: controlProgram.id,
            customLabel: <CustomEllipsisLabel text={controlProgram.name} />,
        })
    );
    // Filter out control program IDs that don't exist in the available options
    const availableIds = new Set(options.map((option) => option.value));
    const filteredValue = value.filter((id) => availableIds.has(id));

    return (
        <MultipleOptionFilterSelect
            options={options}
            placeholder={t("Dashboard_ControlProgramFilter_Placeholder")}
            dropdownMatchSelectWidth={500}
            value={filteredValue}
            onChange={(selected) => onChange(selected as number[])}
            minWidth={300}
        />
    );
}
